/**
 * Feature flags
 * =============
 *
 * Default: ALL features ON. The frontend assumes the backend supports the
 * full Phase 1-7 + Settings surface, which is the v1.1.0 backend.
 *
 * Optional override: explicitly set a flag to `false` in `.env` only if you
 * want to hide a section temporarily (e.g. demo build, or while the backend
 * team is mid-refactor on a specific phase). For normal use you don't need
 * to touch these.
 *
 *   VITE_FEATURE_PHARMACY=false   # to temporarily hide Drug List
 *   VITE_FEATURE_BILLING=false    # to temporarily hide Billing
 *   VITE_FEATURE_SETTINGS=false   # to temporarily hide Settings
 */

function flag(name, defaultValue = true) {
  const raw = import.meta.env[name]
  if (raw === undefined || raw === null || raw === '') return defaultValue
  const v = String(raw).toLowerCase().trim()
  if (v === 'false' || v === '0' || v === 'no' || v === 'off') return false
  return true
}

export const FEATURES = {
  pharmacy: flag('VITE_FEATURE_PHARMACY', true),
  billing: flag('VITE_FEATURE_BILLING', true),
  settings: flag('VITE_FEATURE_SETTINGS', true),
}
